import React from "react";
import PropTypes from "prop-types";
import { DEFAULT_WIDGET_CONFIG } from "../../utils/constants";

// Parses an integer from a numeric input event, falling back to defaultVal on NaN.
const parseNumericInput = (e, defaultVal) => {
  const val = Number.parseInt(e.target.value, 10);
  return Number.isNaN(val) ? defaultVal : val;
};

const AdvancedStep = ({ formData, errors, onInputChange }) => {
  return (
    <div className="widget-form-section">
      <h3>Rate Limits</h3>

      <div className="widget-form-field">
        <label htmlFor="rate_limit_per_ip">Messages per Hour (per IP)</label>
        <input
          id="rate_limit_per_ip"
          type="number"
          value={formData.rate_limit_per_ip}
          onChange={(e) =>
            onInputChange(
              "rate_limit_per_ip",
              parseNumericInput(
                e,
                DEFAULT_WIDGET_CONFIG.RATE_LIMIT_PER_IP_DEFAULT,
              ),
            )
          }
          min={DEFAULT_WIDGET_CONFIG.RATE_LIMIT_PER_IP_MIN}
          max={DEFAULT_WIDGET_CONFIG.RATE_LIMIT_PER_IP_MAX}
          className={errors.rate_limit_per_ip ? "error" : ""}
        />
        {errors.rate_limit_per_ip && (
          <span className="widget-form-error">{errors.rate_limit_per_ip}</span>
        )}
        <small>Maximum messages per hour per visitor IP</small>
      </div>

      <h3 className="widget-form-section-title">Domain & Security</h3>

      <div className="widget-form-field">
        <label htmlFor="allowed_domains">Allowed Domains</label>
        <textarea
          id="allowed_domains"
          value={formData.allowed_domains}
          onChange={(e) => onInputChange("allowed_domains", e.target.value)}
          placeholder="example.com&#10;subdomain.example.com"
          rows={4}
        />
        <small>One domain per line. Leave empty to allow all domains.</small>
      </div>

      <h3 className="widget-form-section-title">Conversation Settings</h3>

      <div className="widget-form-field widget-form-checkbox">
        <label>
          <input
            type="checkbox"
            checked={formData.persist_conversations}
            onChange={(e) =>
              onInputChange("persist_conversations", e.target.checked)
            }
          />
          <span>Persist Conversations</span>
        </label>
        <small>Save conversation history across sessions</small>
      </div>

      <div className="widget-form-field">
        <label htmlFor="conversation_ttl_hours">Conversation TTL (hours)</label>
        <input
          id="conversation_ttl_hours"
          type="number"
          value={formData.conversation_ttl_hours}
          onChange={(e) =>
            onInputChange(
              "conversation_ttl_hours",
              parseNumericInput(
                e,
                DEFAULT_WIDGET_CONFIG.CONVERSATION_TTL_DEFAULT,
              ),
            )
          }
          min={DEFAULT_WIDGET_CONFIG.CONVERSATION_TTL_MIN}
          max={DEFAULT_WIDGET_CONFIG.CONVERSATION_TTL_MAX}
          disabled={!formData.persist_conversations}
          className={errors.conversation_ttl_hours ? "error" : ""}
        />
        {errors.conversation_ttl_hours && (
          <span className="widget-form-error">
            {errors.conversation_ttl_hours}
          </span>
        )}
        <small>
          How long to keep conversations (
          {DEFAULT_WIDGET_CONFIG.CONVERSATION_TTL_MIN}-
          {DEFAULT_WIDGET_CONFIG.CONVERSATION_TTL_MAX} hours /{" "}
          {DEFAULT_WIDGET_CONFIG.CONVERSATION_TTL_MAX / 24} days)
        </small>
      </div>
    </div>
  );
};

AdvancedStep.propTypes = {
  formData: PropTypes.shape({
    rate_limit_per_ip: PropTypes.number,
    allowed_domains: PropTypes.string,
    persist_conversations: PropTypes.bool,
    conversation_ttl_hours: PropTypes.number,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default AdvancedStep;
